import { Skeleton } from '@/components/ui/Skeleton';

export function BalticSkeleton() {
  return (
    <div className="space-y-2">
      {[1, 2, 3, 4, 5].map((index) => (
        <div
          key={index}
          className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
        >
          {/* Skeleton Header */}
          <div className="px-4 py-3 sm:px-5">
            <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3 md:grid-cols-5 md:gap-3">
              {/* Route Code */}
              <div>
                <Skeleton className="mb-2 h-6 w-16" />
                <Skeleton className="h-3 w-20" />
              </div>

              {/* Description - hidden on mobile */}
              <div className="hidden md:block">
                <Skeleton className="mb-2 h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>

              {/* Date */}
              <div>
                <Skeleton className="mb-2 h-4 w-24" />
                <Skeleton className="h-3 w-16" />
              </div>

              {/* Value 1 */}
              <div>
                <Skeleton className="mb-2 h-4 w-20" />
                <Skeleton className="h-3 w-12" />
              </div>

              {/* Value 2 */}
              <div>
                <Skeleton className="mb-2 h-4 w-20" />
                <Skeleton className="h-3 w-12" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
